import Configurable from '@kopapro/components/preview/configurable/configurable';

export default Configurable;
